import React, { Component } from 'react';

import PropTypes from 'prop-types';
import Container from 'react-bootstrap/Container';
import Nav from 'react-bootstrap/Nav';
import Navbar from 'react-bootstrap/Navbar';
import { Link, withRouter } from 'react-router-dom';

import logo from '@src/img/logos/foremost-logo.svg';

import Favorites from '@src/components/header/FavoritesMenu';

import Alerts from './AlertsMenuItem';
import CartMenuItem from './CartMenuItem';
import EssentialLinks from './EssentialLinksMenuItem';
import LogoutItem from './HeaderLogoutItem';
import Help from './HelpMenuItem';
import SearchItem from './SearchItem';

class HeaderMenuTop extends Component {
    static propTypes = {
        topMenu: PropTypes.arrayOf(PropTypes.object).isRequired,
        uncheckedCount: PropTypes.object,
        alerts: PropTypes.object,
        cartItems: PropTypes.object,
        onMouseOver: PropTypes.func.isRequired,
        onAlertFocus: PropTypes.func,
    };

    renderItem = (menu) => {
        switch (menu.id) {
        case 'essential_links':
            return <EssentialLinks key={menu.id} {...menu} />;
        case 'alerts':
            return (
                <Alerts
                    key={menu.id}
                    {...menu}
                    uncheckedCount={this.props.uncheckedCount}
                    alertsData={this.props.alerts}
                    onFocus={this.props.onAlertFocus}
                />
            );
        case 'favorites':
            return (
                <Favorites
                    key={menu.id}
                    {...menu}
                />
            );
        case 'help':
            return (
                <Help
                    key={menu.id}
                    {...menu}
                />
            );
        case 'logout':
            return <LogoutItem key={menu.id} {...menu} />;
        case 'search':
            return <SearchItem key={menu.id} {...menu} />;
        case 'cart':
            return (
                <CartMenuItem
                    key={menu.id}
                    {...menu}
                    cartItemsData={this.props.cartItems}
                />
            );
        default:
            return null;
        }
    };

    render() {
        const { topMenu, onMouseOver } = this.props;

        return (
            <Navbar
                key="header-menu-top-row"
                id="header-menu-top-row"
                className="header-menu-top-row p-0"
                expand="lg"
                onMouseOver={onMouseOver}
            >
                <Container>
                    <Navbar.Brand as={Link} to="/" tabIndex={1000}>
                        <img src={logo} className="nav-brand-img d-inline-block align-middle img-fluid" alt="Foremost Insurance Group" />
                        <>
                            <span className="nav-brand-pipe align-middle" />
                            <span className="nav-brand-title align-middle">
                                Producer News Portal
                            </span>
                        </>
                    </Navbar.Brand>
                    <Nav id="header-menu-top-nav" className="justify-content-end w-100">
                        {topMenu.map((menu) => this.renderItem(menu))}
                    </Nav>
                </Container>
            </Navbar>
        );
    }
}

export default withRouter(HeaderMenuTop);

